/* tslint:disable */
const TRANSLATIONS: any = {
  "i18n.actionBar.cropImage": "Prelucrează",
  "i18n.actionBar.removeImage": "Șterge",
  "i18n.actionBar.swapImage": "Înlocuiește",
  "i18n.additionalInfoItemLayers.smartSorted.new": "NOU!",
  "i18n.additionalProducts.addToCart": "Adaugă la comandă",
  "i18n.additionalProducts.frame.description": "Ramă din aluminiu de înaltă calitate: argintiu mat, sticlă premium autentică, nu este nevoie de adeziv",
  "i18n.additionalProducts.frame.emotionalHook": "♥️ Sfat util:",
  "i18n.additionalProducts.frame.subtitle": "Puzzle-ul finalizat este o amintire prețioasă – cu <b>rama</b> noastră, îl poți pune perfect în valoare.",
  "i18n.additionalProducts.frame2023.description": "Ramă din fibre de lemn de înaltă calitate – ușor de montat, fără sticlă, cu adeziv pentru puzzle inclus",
  "i18n.additionalProducts.framePlastic.description": "Ramă din aluminiu de înaltă calitate: argintiu mat, sticlă sintetică antireflex, nu este nevoie de adeziv",
  "i18n.additionalProducts.glue.description": "Pentru maximum două puzzle-uri de 1000 de piese, cu burete de aplicare inclus.",
  "i18n.additionalProducts.glue.hook": "Transformă puzzle-ul într-un tablou.\nFixează și protejează puzzle-ul pe termen lung.",
  "i18n.additionalProducts.roll.description": "Pentru puzzle-uri de la 48 la 2000 de piese",
  "i18n.additionalProducts.roll.hook": "Nu ai o masă liberă? Nicio problemă.\nRulează puzzle-ul, depozitează-l și continuă mai târziu.",
  "i18n.adventCalendarOverlay.activate": "Vezi previzualizarea celor 24 de ușițe",
  "i18n.adventCalendarOverlay.deactivate": "Ascunde previzualizarea celor 24 de ușițe",
  "i18n.adventCalendarOverlay.notice": "(Numerele și liniile nu vor fi imprimate)",
  "i18n.button.addToCart": "Adaugă în coș",
  "i18n.button.apply": "Confirmă",
  "i18n.button.back": "Înapoi",
  "i18n.button.cancel": "Anulează",
  "i18n.button.cancelAndFix": "Modifică acum",
  "i18n.button.chooseSmartSorted": "Alege SMART SORTED ",
  "i18n.button.close": "Închide",
  "i18n.button.continue": "Înainte",
  "i18n.button.createNewTextPlaceholders": "Introdu textul",
  "i18n.button.ignore": "Ignoră",
  "i18n.button.ignoreAndContinue": "Continuă totuși",
  "i18n.button.mobile.createNewTextPlaceholders": "Text",
  "i18n.button.noChanges": "Nicio modificare",
  "i18n.button.ok": "Am înțeles!",
  "i18n.button.photos": "Poze",
  "i18n.button.retry": "Încearcă din nou",
  "i18n.button.uploadPhotos": "Încarcă poze",
  "i18n.button.withSmartSorted": "Cu SMART SORTED",
  "i18n.button.withoutSmartSorted": "Fără SMART SORTED",
  "i18n.control.colorChooser.color": "Culoare",
  "i18n.control.fontChooser.placeholderText": "Font",
  "i18n.control.imageQuality.checkImages": "Verifică imaginile",
  "i18n.control.imageQuality.imageSuitability": "Calitatea imaginii:",
  "i18n.control.imageQuality.indicatorAltText": "Calitatea imaginii",
  "i18n.control.imageZoom.zoom": "Zoom:",
  "i18n.control.templateChooser.title": "Alege designul",
  "i18n.control.textEditing.rejectMessage.characterWontFit": "Pentru o mai bună lizibilitate,  scurtează  lungimea textului / a rândului.",
  "i18n.control.textEditing.rejectMessage.fontFamilyTooLarge": "Fontul ales este prea mare pentru acest text. Tipul de font selectat este prea mare pentru acest text.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooLarge": "Pentru acest text a fost aleasă dimensiunea maximă a fontului.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooSmall": "A fost selectată dimensiunea minimă posibilă a fontului.",
  "i18n.control.textEditing.rejectMessage.insertLineBreak": "Te rugăm să adaugi un rând nou.",
  "i18n.control.textEditing.rejectMessage.insertLineBreakOrResizeTextField": "Inserează un rând nou sau mărește câmpul pentru text",
  "i18n.control.textEditing.rejectMessage.invalidCharacters": "Te rugăm să verifici datele introduse, nu toate caracterele sunt acceptate de acest font.",
  "i18n.control.textEditing.rejectMessage.maxCharactersReached": "Numărul maxim de caractere a fost atins.",
  "i18n.control.textEditing.rejectMessage.maxLinesReached": "Ai ajuns la limita maximă de rânduri. Numărul maxim de rânduri a fost atins.",
  "i18n.control.textEditing.rejectMessage.resizeTextField": "Te rugăm să mărești câmpul pentru text.",
  "i18n.dialog.deletePlaceholder.message": "Această acțiune nu poate fi anulată",
  "i18n.dialog.deletePlaceholder.title": "Sigur vrei să ștergi spațiul rezervat?",
  "i18n.dialog.error.title": [
    "A apărut o eroare",
    "Au apărut mai multe erori"
  ],
  "i18n.dialog.insufficientImageQuality.message": "Rezoluția imaginii este prea mică pentru o imprimare de calitate a motivului!",
  "i18n.dialog.smartSorted.message": "Cu SMART SORTED, poți asambla inovativ și ușor motivul din 1000 de piese, chiar dacă nu ai o imagine model.",
  "i18n.dialog.smartSorted.title": "Puzzle-Erfolgserlebnis garantiert . Satisfacție – garantată la asamblarea puzzle-ului.",
  "i18n.dialog.unchangedPlaceholders.boxTitle.message": "Te rugăm să faci click pe „{{text}}“, pentru a modifica titlul după preferințele tale.",
  "i18n.dialog.unchangedPlaceholders.boxTitle.title": "Titlul cutiei nu a fost modificat.",
  "i18n.dialog.unchangedPlaceholders.buttons.clear.label": "Continuă făra text",
  "i18n.dialog.unchangedPlaceholders.image.message": [
    "Te rugăm să introduci fotografia făcând clic pe spațiul rezervat imaginii.",
    "Te rugăm să introduci fotografiile făcând clic pe spațiul rezervat  imaginilor."
  ],
  "i18n.dialog.unchangedPlaceholders.image.title": [
    "Un spațiu rezervat pentru imagine nu a fost completat.",
    "Mai multe spații rezervate nu au fost modificate."
  ],
  "i18n.dialog.unchangedPlaceholders.message": [
    "Un spațiu rezervat nu a fost modificat. ",
    "Mai multe spații rezervate nu au fost modificate."
  ],
  "i18n.dialog.unchangedPlaceholders.misc.message": [
    "Apasă pe spațiile rezervate pentru imagine și text pentru a ajusta designul conform preferințelor tale.",
    "Apasă pe spațiile rezervate pentru imagini și texte pentru a ajusta  designul conform preferințelor tale."
  ],
  "i18n.dialog.unchangedPlaceholders.misc.title": [
    "Un spațiu rezervat nu a fost modificat.",
    "Mai multe spații rezervate nu au fost modificate."
  ],
  "i18n.dialog.unchangedPlaceholders.text.message": [
    "Apasă pe câmpul de text pentru a modifica textul conform preferințelor tale.",
    "Apasă pe câmpurile de texte pentru a modifica textele conform  preferințelor tale. "
  ],
  "i18n.dialog.unchangedPlaceholders.text.title": [
    "Un câmp de text nu a fost modificat.",
    "Mai multe câmpuri de texte nu au fost modificate."
  ],
  "i18n.dialog.unchangedPlaceholders.title": "Spații rezervate nemodificate",
  "i18n.error.additionalInfoItemsError.message": "Un element informațional nu a putut fi încărcat.",
  "i18n.error.additionalInfoItemsError.title": "Eroare de încărcare",
  "i18n.error.deprecatedBrowserError.message": "Browserul utilizat  nu mai este compatibil. Te rugăm să îl actualizezi la o versiune mai nouă.",
  "i18n.error.deprecatedBrowserError.title": " ",
  "i18n.error.designerExpiredError.message": "Procesul a fost întrerupt din cauza duratei prea mari și nu poate fi continuat. Te rugăm să începi din nou.",
  "i18n.error.designerExpiredError.title": "Procesul de creare s-a finalizat",
  "i18n.error.fontLoadingError.message": "Un tip de font nu a putut fi încărcat.",
  "i18n.error.fontLoadingError.title": "Eroare de încărcare",
  "i18n.error.imageLoadingError.message": "O imagine nu a putut fi încărcată. A fost eliminată din galerie și zona de editare.",
  "i18n.error.imageLoadingError.title": "Eroare de încărcare",
  "i18n.error.imageProvisionError.message": "Una sau mai multe imagini nu au putut fi procesate. Este posibil ca formatul să nu fie acceptat.",
  "i18n.error.imageProvisionError.title": "O imagine nu a putut fi procesată",
  "i18n.error.imageSelectionError.message": "Fișierul „{{reference1}}“ nu a putut fi procesat.",
  "i18n.error.imageSelectionError.title": "Eroare la încărcarea imaginii",
  "i18n.error.imageSizeLimitExceededError.message": "Imaginea pe care ai încărcat-o are dimensiuni prea mari. Din motive tehnice, nu poate fi  procesată.\nTe rugăm să micșorezi imaginea la mai puțin de 180 de megapixeli și să o încarci din nou.",
  "i18n.error.imageSizeLimitExceededError.title": "Eroare la încărcarea imaginii",
  "i18n.error.imageUploadError.message": "Se pare că există o problemă cu conexiunea la internet.\nTe rugăm să încerci din nou mai târziu.",
  "i18n.error.imageUploadError.title": "Eroare la încărcarea imaginii",
  "i18n.error.inlineSVGLoadingError.message": "Cadrul de toleranță „{{reference1}}“ nu a putut fi încărcat.",
  "i18n.error.inlineSVGLoadingError.title": "Eroare de încărcare",
  "i18n.error.invalidCharConfigError.message": "Fontul este nefuncțional eronat și nu poate fi utilizat.",
  "i18n.error.invalidCharConfigError.title": "Font eronat",
  "i18n.error.malformedProductError.message": "Unul sau mai multe produse nu au putut fi încărcate pe server.  Este posibil ca produsul să nu mai fie disponibil sau configurarea a durat prea mult timp.\n\nNe pare rău!  Te rugăm să reiei procesul. ",
  "i18n.error.malformedProductError.title": "Eroare produs",
  "i18n.error.notInStockError.message": "Produsul selectat de tine nu este disponibil momentan. n\nApasă pe logo-ul din stânga sus pentru a reveni la pagina principală și a alege un alt produs.",
  "i18n.error.notInStockError.title": " ",
  "i18n.error.offlineNotice": "Se pare că conexiunea ta la internet a fost întreruptă. Poți continua procesul de creare imediat ce conexiunea este restabilită.",
  "i18n.error.templateLoadingError.message": "Șablonul „{{ error.reference[0] }}“ nu a putut fi încărcat.\nTe rugăm să încerci din nou mai târziu.",
  "i18n.error.templateLoadingError.title": "Eroare de încărcare",
  "i18n.error.transformationError.message": "Transformarea nu a fost efectuată. ",
  "i18n.error.transformationError.title": "Eroare la transformare",
  "i18n.error.traudlLoadingError.message": "Încearcă din nou sau alege o altă imagine.",
  "i18n.error.traudlLoadingError.title": "Filtrul AI nu a putut fi aplicat.",
  "i18n.error.unsupportedMediaTypeError.message": "Formatul imaginii nu este acceptat pentru „{{reference1}}“.",
  "i18n.error.unsupportedMediaTypeError.title": "Eroare la încărcarea imaginii",
  "i18n.error.uploadProductError.message": "Unul sau mai multe produse nu au putut fi transferate către server.\nPosibil să existe o problemă cu conexiunea la Internet.",
  "i18n.error.uploadProductError.title": "Eroare de transmitere",
  "i18n.error.zoomModeError.message": "Textul tău din designul anterior nu a putut fi preluat și a fost resetat.",
  "i18n.error.zoomModeError.title": "Textul nu a fost preluat.",
  "i18n.gallery.uploadPhotos.info": "Apasă pe butonul „Încarcă poze”.",
  "i18n.gallery.uploadProgress": [
    "Fotografia se încarcă",
    "{{current}} din {{total}} fotografiile se încarcă"
  ],
  "i18n.price.price": "Preț",
  "i18n.price.reduction": "Economisești",
  "i18n.price.total": "Preț total",
  "i18n.priceDisplay.times": [
    "{{value}} Bucată à {{pricePerUnit}}",
    "{{value}} Bucăți à {{pricePerUnit}}"
  ],
  "i18n.progress.stepAdditionalProducts": "Accesorii (optional)",
  "i18n.progressOverlay.message.lines.one": "Îți mulțumim pentru creația frumoasă!",
  "i18n.progressOverlay.message.lines.two": "Pregătim totul pentru tine...",
  "i18n.template.insertText": "Introdu textul aici",
  "i18n.toolbox.gallery.title": "Alege fotografii",
  "i18n.toolbox.image.title": "Editează imaginea",
  "i18n.toolbox.layout.template.suitableFor": [
    "1 imagine",
    "{{value}} imagini"
  ],
  "i18n.toolbox.layout.title": "Alege designul",
  "i18n.toolbox.layout.triggerText": "Designuri",
  "i18n.toolbox.preview.title": "Previzualizare 3D",
  "i18n.toolbox.productChooser.title": "Schimbă produsul",
  "i18n.toolbox.productChooser.triggerText": "Produs",
  "i18n.toolbox.text.title": "Editează textul"
};


export class LocaleRoRO {
  public getPlural(n: number): number
  {
    const pluralForm = (n != 1);
    if (typeof(pluralForm) === 'boolean') {
      return pluralForm ? 1 : 0;
    }
    return pluralForm;
  }
  public getTranslations(): any
  {
    return TRANSLATIONS;
  }
}
/* tslint:enable */
